// extracted by mini-css-extract-plugin
export default {"container":"KeyValue_container__9gUGp","title":"KeyValue_title__lvqVv","value":"KeyValue_value__hCFTR"};